import { render, staticRenderFns } from "./StatisticsDataPieChart.vue?vue&type=template&id=28c96158"
import script from "./StatisticsDataPieChart.vue?vue&type=script&lang=js"
export * from "./StatisticsDataPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports